import { configureStore } from "@reduxjs/toolkit";
import { api } from "../features/api/api";
import authSlice from "../features/auth/authSlice";
import projectSlice from "../features/project/projectSlice";

export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        auth: authSlice,
        project: projectSlice,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(api.middleware),
});
